export default "__VITE_ASSET__B2ws7YJD__"